import { formatDate } from '../../../core/helpers/default';
import { GENERATE_PETITION_SUCCESS } from '../actionTypes';
import {
  GET_PROSPECTS_REQUEST,
  GET_PROSPECTS_SUCCESS,
  GET_PROSPECTS_FAILED,
  SET_SELECTED_PROSPECT,
  SELECT_ALL_PROSPECTS,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 5,
  prospectIds: [],
};

const toggleProspectIds = (arr, id) => {
  if (arr.some((i) => i === id)) {
    return arr.filter((i) => i === id);
  }
  return [...arr, id];
};

const prospectTabReducer = (state = initialState, {
  type, error, data, meta, prospectId, selectAll,
}) => {
  switch (type) {
    case GET_PROSPECTS_REQUEST:
      return { ...state, loading: true };
    case GET_PROSPECTS_SUCCESS:
      return {
        ...state,
        data: data.map((i) => ({
          ...i,
          _selected: false,
          date_requested: i.date_requested ? formatDate(i.date_requested) : '',
          date_generated: i.date_generated ? formatDate(i.date_generated) : '',
        })),
        search: meta.search,
        sort: meta.sort,
        order: meta.order,
        page: meta.current_page,
        lastPage: meta.last_page,
        loading: false,
        prospectIds: [],
      };
    case GET_PROSPECTS_FAILED:
      return { ...state, loading: false, error };
    case SET_SELECTED_PROSPECT:
      return {
        ...state,
        prospectIds: toggleProspectIds(state.prospectIds, prospectId),
        data: state.data.map((i) => (prospectId === i.id
          ? ({ ...i, _selected: !i._selected }) : i)),
      };
    case SELECT_ALL_PROSPECTS:
      return {
        ...state,
        prospectIds: selectAll ? state.data.map(({ id }) => id) : [],
        data: state.data.map((i) => ({ ...i, _selected: selectAll })),
      };
    case GENERATE_PETITION_SUCCESS:
      return {
        ...state,
        prospectIds: [],
        data: [],
        loading: false,
      };
    default:
      return state;
  }
};

export default prospectTabReducer;
